import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { STRINGS } from '../lib/i18n-strings';

const I18nContext = createContext(null);
const STORAGE_KEY = 'valutdocu:lang';

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem(STORAGE_KEY) || 'en';
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
    document.documentElement.setAttribute('lang', next);
  }, []);

  const t = useCallback(
    (key, vars = {}) => {
      const dict = STRINGS[lang] || STRINGS.en;
      let str = dict[key] ?? STRINGS.en[key] ?? key;
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
      });
      return str;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
